import {
    faFile,
    faFileExcel,
    faFileImage,
    faFileLines,
    faFilePdf,
    faFileWord,
    IconDefinition
} from '@fortawesome/free-solid-svg-icons';

export const fileIcon = (mimeType?: string | null): IconDefinition => {
    if (!mimeType) return faFile;
    if (mimeType === 'application/pdf') return faFilePdf;
    if (mimeType.startsWith('image/')) return faFileImage;
    if (mimeType.includes('word') || mimeType.includes('opendocument.text')) return faFileWord;
    if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return faFileExcel;
    if (mimeType.startsWith('text/')) return faFileLines;

    return faFile;
};

const sizeFormat = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });

export const formatFileSize = (bytes?: number | null): string | null => {
    if (!bytes) return null;
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${sizeFormat.format(bytes / 1024)} KB`;

    return `${sizeFormat.format(bytes / 1024 / 1024)} MB`;
};
